module.exports = __webpack_public_path__ + "img/定位二维码.d2be0849.svg";